import React from 'react';
import { useTranslation } from 'react-i18next';

import PartnerExchangeItem from './PartnerExchangeItem';
import styled, { css } from 'styled-components';

const exchanges = t => [
  {
    type: 'ddex',
    image:
      'https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/logo/logo-ddex.png',
    description: t('landing.partnership.ddex.description', 'Trade IDRT on decentralized exchange'),
    articleLink: 'https://rupiahtoken.com/blog/rupiah-token-idrt-is-available-on-ddex-io',
    link: 'https://ddex.io/trade/IDRT-USDT'
  },
  {
    type: 'uniswap',
    image:
      'https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/logo/logo-uniswap.png',
    description: t(
      'landing.partnership.uniswap.description',
      'Instantly swap IDRT with more than 600+ tokens (USDC, BAT, ZRX, etc)'
    ),
    articleLink:
      'https://medium.com/rupiahtoken-blog/trade-idrt-with-600-other-tokens-on-uniswap-f916eaee8ba6',
    link: 'https://uniswap.exchange/swap/0x998FFE1E43fAcffb941dc337dD0468d52bA5b48A'
  },
  {
    type: 'binance',
    image:
      'https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/logo/logo-binance-dex.png',
    description: t(
      'landing.partnership.binance_dex.description',
      'IDRTB (Binance Chain version of IDRT) is now tradable on Binance DEX!'
    ),
    articleLink: t(
      'landing.partnership.binance_dex.article.link',
      'https://rupiahtoken.com/blog/rupiah-token-listed-as-the-first-non-usd-stablecoin-trading-pair-on-binance-dex'
    ),
    link: t(
      'landing.partnership.binance_dex.exchange.link',
      'https://www.binance.org/en/trade/BNB_IDRTB-178'
    )
  }
];

const PartnerExchangeTitle = styled.h2`
  text-align: center;
`;

const PartnerExchangesList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export default function PartnerExchanges(props) {
  const { t } = useTranslation();
  return (
    <div>
      <PartnerExchangeTitle>
        {t('landing.partnership.title', 'Partner Exchanges')}
      </PartnerExchangeTitle>
      <PartnerExchangesList>
        {exchanges(t).map(exchange => (
          <PartnerExchangeItem key={exchange.link} {...exchange} />
        ))}
      </PartnerExchangesList>
    </div>
  );
}
